<template>
  <div>
    <el-row>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="handleOperate('create')"
        >添加</el-button
      >
    </el-row>
    <el-row :gutter="6">
      <el-col :span="4">
        <el-select
          clearable
          v-model="searchData.developerName"
          filterable
          placeholder="请选择开发者名称"
        >
          <el-option
            v-for="item in CompanyNameList"
            :key="item.id"
            :label="`${item.developerName ? `${item.developerName}` : ''}`"
            :value="item.developerName"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          style="margin-right: 10px"
          clearable
          filterable
          size="small"
          v-model="searchData.businessName"
          placeholder="商务对接人"
        >
          <el-option
            v-for="item in businessNameList"
            :key="item.id"
            :value="item.name"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="searchData.status" placeholder="合作状态" clearable>
          <el-option
            v-for="item in cooperateStatus"
            :key="item.key"
            :value="item.key"
            :label="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="handleSearch()">
          查询
        </el-button>
        <ExportTable
          v-has="'download'"
          class="ml10"
          @download="getDownloadList"
        ></ExportTable>
      </el-col>
    </el-row>
    <PageTable
      :columns="columns"
      :tableData="tableData"
      @page-change="handleChangePage"
      @customSortChange="customSortChange"
    >
      <template slot-scope="{ row }" slot="createTime">
        {{ getFormattedDate(row.createTime) }}
      </template>
      <template slot-scope="{ row }" slot="modifyTime">
        {{ getFormattedDate(row.modifyTime) }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <el-tag :type="row.status | tagType(cooperateStatus)">
          {{ row.status | typeDesc(cooperateStatus) }}
        </el-tag>
      </template>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="{ row }">
          <el-button type="text" @click="lookAppinfo(row)">
            查看应用
          </el-button>

          <el-button type="text" @click="handleOperate('edit', row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </PageTable>
    <el-dialog
      top="10vh"
      destroy-on-close
      :close-on-click-modal="false"
      :title="operationType | operationTypeDesc"
      :visible.sync="dialogVisible"
      @closed="handleResetCreate()"
    >
      <Create
        ref="createRef"
        v-if="operationType === 'create' || operationType === 'edit'"
        :detailData="detailData"
        :businessNameList="businessNameList"
        @submit="handleCreateApp"
        @cancle="handleCancel('list')"
      />
    </el-dialog>
  </div>
</template>
<script>
import {
  cooperateStatus,
  devStatusList,
  identityTypeList,
  MAXSIZE,
  MAXSIZEDOWN,
} from "@/common/constant/constant.js";
import { getFormattedDate } from "@/common/utils/utils.js";
import {
  getDeveloperUserList,
  createAppInfo,
  editAppInfo,
  resetPassword,
  updateState,
  getVerifyInfo,
  requestRefund,
  getAccountBalance,
  getHonorManageUser,
  getBusinessManagerList,
} from "./indexServe.js";
import Create from "./Create.vue";
import Detail from "./Detail.vue";
// import Refund from "./Refund.vue";
import PageTable from "@/components/PageTable.vue";
import ExportTable from "@/components/ExportTable.vue";
// import ExplainTip from "@/components/ExplainTip.vue";
export default {
  name: "developerListGp",
  components: { Create, Detail, ExportTable, PageTable },
  data() {
    return {
      getFormattedDate,
      operationType: "", // 记录当前操作模式新建-create、编辑-edit
      dialogVisible: false,
      refundVisible: false,
      devStatusList,
      cooperateStatus,
      identityTypeList,
      searchData: {},
      businessName: "",
      detailData: {},
      companyNameStr: "",
      CompanyNameList: [],
      honorManageUser: [],
      businessNameList: [],
      imgList: [], // 认证详情的图片列表
      tableData: {
        list: [],
      },
      Balance: null,
      BalanceOptions: [
        { value: 1, label: "0" },
        { value: 2, label: "1—1000" },
        { value: 3, label: "1001—2000" },
        { value: 4, label: "2000以上" },
      ],
      columns: [
        {
          key: "id",
          label: "开发者ID",
        },
        {
          key: "developerName",
          label: "开发者名称",
        },
        {
          key: "businessName",
          label: "商务对接人",
        },
        {
          slot: "createTime",
          label: "创建时间",
        },
        {
          slot: "modifyTime",
          label: "修改时间",
        },
        {
          slot: "status",
          label: "合作状态",
        },
      ],
    };
  },
  created() {
    this.getTableList();
    // this.getHonorManageUserList();
    this.init();
    this.getBusManaList();
  },
  methods: {
    handleCancel(showArea) {
      this.showArea = showArea;
      this.detailData = {};
      this.dialogVisible = false;
      this.operationType = "";
    },
    handleResetCreate() {
      this.$refs.createRef && this.$refs.createRef.resetFields();
      this.handleCancel("list");
    },
    // 获取商务人员列表
    async getBusManaList() {
      const res = await getBusinessManagerList({
        page: 1,
        size: MAXSIZE,
      });
      if (res && res.code === 0) {
        this.businessNameList = res.data.list;
      }
    },
    // 事件监听
    handleChangePage({ page, size }) {
      this.getTableList({ page, size });
    },
    customSortChange(column) {
      if (column) {
        if (column.prop === "balanceAble" && column.order === "ascending") {
          this.searchData.sortType = 1;
        } else if (
          column.prop === "balanceAble" &&
          column.order === "descending"
        ) {
          this.searchData.sortType = 2;
        } else if (
          column.prop === "billableAmount" &&
          column.order === "ascending"
        ) {
          this.searchData.sortType = 3;
        } else if (
          column.prop === "billableAmount" &&
          column.order === "descending"
        ) {
          this.searchData.sortType = 4; //降序
        }
        this.getTableList({ page: 1 });
      }
    },
    handleSearch() {
      this.getTableList({ page: 1 });
    },
    handleView(row) {
      this.setDialogVisible(true);
      // this.getVerifyInfo(row);
      this.getVerifyInfo({ id: row.identityId });
    },
    lookAppinfo(row) {
      this.$router.push({
        path: "/business/appManagement/apkManagementGp",
        query: { creatorId: row.id },
      });
    },
    handleResetPassword(row) {
      this.$confirm("此操作将重置密码, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.resetPassword(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    refundBtn(row) {
      getAccountBalance({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.detailData = { ...row, ...res.data };
          this.refundVisible = true;
        }
      });
    },
    refundSubmit(data) {
      if (data) {
        requestRefund(data).then((res) => {
          if (res.code == 0) {
            this.getTableList();
          }
        });
        this.refundVisible = false;
      } else {
        this.refundVisible = false;
      }
    },
    handleUpdateState(row) {
      let decs = `是否冻结账号${row.account}，冻结后用户将无法使用`;
      let state = 2;
      if (row.state == 2) {
        decs = `是否恢复使用账号${row.account}`;
        state = 1;
      }
      this.$confirm(decs, "提示", {
        type: "warning",
      })
        .then(() => {
          this.updateState({ userId: row.id, state });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async getTableList(params, isDownload) {
      const data = {
        backendType: 1,
        page: 1,
        size: 10,
        ...this.searchData,
        ...params,
      };
      if (data.status == "") delete data.status;
      const res = await getDeveloperUserList(data);
      if (res) {
        // 下载时，不需要更新到table
        if (!isDownload) {
          this.tableData = res.data;
        }
        return res.data;
      }
    },
    async resetPassword(params) {
      const res = await resetPassword(params);
      if (res) {
        if (params.email) {
          this.$alert("新密码已经发送至邮箱账户", "提示");
        } else {
          this.$alert("新密码已经发送至手机", "提示");
        }
        this.getTableList();
      }
    },
    async updateState(params) {
      const res = await updateState(params);
      if (res) {
        this.$message.success("操作成功");
        this.getTableList();
      }
    },
    async getVerifyInfo(params) {
      const res = await getVerifyInfo(params);
      // console.log("res.data", res.data);
      if (res) {
        this.detailData = res.data;
        if (!res.data.identityAdjunctVo) {
          this.detailData.identityAdjunctVo = {};
        }
        const identityAdjunctVo = res.data.identityAdjunctVo;
        const imgList = [];
        if (identityAdjunctVo) {
          for (let key in identityAdjunctVo) {
            imgList.push(identityAdjunctVo[key]);
          }
        }
        this.imgList = imgList;
      }
    },
    setDialogVisible(val) {
      this.dialogVisible = val;
    },
    async getCompanyNameList() {
      const res = await getDeveloperUserList({ size: MAXSIZE, backendType: 1 });
      if (res && res.code === 0 && res.data) {
        this.CompanyNameList = res.data.list || [];
      }
    },
    handleChange(val) {
      this.searchData.companyName = val.split(",")[1];
    },
    changeBusinessName(val) {
      this.searchData.businessName = val.split(",")[1];
    },
    // 其他
    init() {
      this.getCompanyNameList();
    },
    async getHonorManageUserList() {
      const res = await getHonorManageUser({ page: 1, size: MAXSIZE });
      if (res && res.code == 0 && res.data) {
        this.honorManageUser = res.data || [];
      }
    },
    async handleOperate(operationType, row) {
      this.operationType = operationType;
      this.dialogVisible = true;
      this.detailData = { ...row };
    },
    async getDownloadList(callback) {
      const res = await this.getTableList(
        { page: 1, size: MAXSIZEDOWN, backendType: 1 },
        true
      );
      if (res) {
        const headerDisplay = {};
        this.columns.forEach((item) => {
          const key = item.key || item.slot;
          if (key !== "action") {
            headerDisplay[key] = item.label;
          }
        });

        // 处理导出的数据
        const list = res.list.map((i) => ({
          ...i,
          state: this.$options.filters["typeDesc"](i.state, this.devStatusList),
          // identityType: this.$options.filters["typeDesc"](
          //   i.identityType,
          //   this.identityTypeList
          // ),
          // balanceAble: this.$options.filters["numberFilter"](i.balanceAble, ""),
          // billableAmount: this.$options.filters["numberFilter"](
          //   i.billableAmount,
          //   ""
          // ),
        }));
        callback({
          fileName: "开发者列表-GP",
          headerDisplay,
          list,
        });
      }
    },

    handleCreateApp(formData) {
      const funcName = formData.id ? editAppInfo : createAppInfo;
      funcName(formData).then((res) => {
        if (res && res.code === 0) {
          this.handleResetCreate();
          this.getTableList(); // 成功后刷新列表
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select {
  width: 100%;
}
</style>
